/* import __COLOCATED_TEMPLATE__ from './node.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();